var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.098,
    viewBox: "0 0 18 18.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41308",
    "data-name": "Path 41308",
    d: "M2.65.373a3.314,3.314,0,0,0-.777.282,2.7,2.7,0,0,0-1.3,1.587L.49,2.489V16.317l.082.248a2.728,2.728,0,0,0,1.762,1.791l.228.083,2.924.01,2.924.01v-6.4H6.3V8.872H8.41V7.82a4.841,4.841,0,0,1,.332-2.467,3.111,3.111,0,0,1,1.54-1.521c.571-.265.9-.3,2.913-.3h1.572V6.715h-3.2V8.872h3.184l-.263,1.592-.263,1.592H11.571v6.4l2.4-.011,2.4-.011.228-.082a2.861,2.861,0,0,0,1.275-.872,3.3,3.3,0,0,0,.517-1.042,1.563,1.563,0,0,1,.074-.256c.045-.088.041-13.618,0-13.59-.02.012-.035-.015-.035-.063a2.582,2.582,0,0,0-.269-.772A2.721,2.721,0,0,0,16.593.45L16.365.367l-6.813,0C5.8.36,2.7.365,2.65.373M.49,9.4c0,3.744,0,5.276.009,3.4S.5,7.871.5,6,.49,5.658.49,9.4",
    transform: "translate(-0.49 -0.362)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.855d00ad9fac4838e7fd47ce07c4bb99.svg";
export { ForwardRef as ReactComponent };